import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CInputTextArea } from "../../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../../context";
import { AddJobsApi, JobsGroupApi } from "../../../api";
import { Link, useNavigate } from "react-router-dom";

export const JobAdd = () => {
    const navigate = useNavigate()
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const [listGroup, setListGroup] = useState<any>([])


    const onFinishAdd = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await AddJobsApi(formRef)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت ثبت گردید", { type: "success" })
            navigate('/p/settings/job');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }

    const getListGroup = async () => {
        let res = await JobsGroupApi()
        if (res.success) {
            setListGroup(res.data)
        }
    }

    useEffect(() => {
        document.title = "اضافه کردن شغل | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 1, })
        getListGroup()
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">اضافه کردن گروه‌شغلی</h1>

            <form ref={formRef} onSubmit={onFinishAdd} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">


                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-[50%]  h-full pl-1">
                                <CInputText name="name" title="عنوان شغل" type="text" required={true} />
                            </div>
                            <div className=" w-[50%] h-[50px] pl-1 sm:pl-2">
                                <CSelect name="group" placeholder={'گروه شغلی'} title="گروه شغلی" border={true} required={true}>
                                    {listGroup.map((item: any, index: number) =>
                                        <option key={index} value={item.id}>{item.name}</option>
                                    )}
                                </CSelect>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%]  flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-full pl-1">
                                <CInputTextArea name="description" title="توضیحات" custom_class="min-h-[100px]"  />
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-[50%] h-full pl-1 flex items-center">
                                <span className="text-sm mx-2">فعال</span>
                                <div className="flex flex-col justify-center items-center">
                                    <span className="text-[10px]  mb-2 text-center ">وضعیت گروه شغلی</span>
                                    <CToggle name="status" defaultChecked={true} />
                                </div>
                                <span className="text-sm mx-2">غیر فعال</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/settings/job'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>



        </div>
    )
}
